const getProductById = async(handle) => {
	 let productData = await fetch(`/products/${handle}.js`).then(response => response.json());
    return await productData.variants;
}
const variantATC = (self, variantId) => {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: 1,
    id: variantId
    },
    dataType: 'json', 
    success: function (data, textStatus, xhr) { 
      // self.find('.product-actions-container .added-to-cart-notice').addClass('active-note');
      // self.find('.product-actions-container .added-to-cart-notice').text('added to bag');
      
    },
    complete: async function (xhr, textStatus) {
      if(xhr.status == 200){
        let cartRes = await fetch(window.location.href);
        cartRes = await cartRes.text();
        let parser = new DOMParser();
        let doc = parser.parseFromString(cartRes, 'text/html');
        let countUpdate = doc.querySelector('.header__icon--cart').innerHTML;
        document.querySelector('.header__icon--cart').innerHTML = countUpdate;
        let drawerUpdate = doc.querySelector('cart-drawer').innerHTML;
        document.querySelector('cart-drawer').classList.remove("is-empty");
        document.querySelector('cart-drawer').innerHTML = drawerUpdate;
        await document.querySelector('.header__icon--cart').click();
      } else {
        // self.find('.product-actions-container .added-to-cart-notice').text('sold out');
        // self.find('.product-actions-container .added-to-cart-notice').addClass('active-note');
      }
    }
  });
}

function vatinatAddtocart(self, variantId, pid){
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: 1,
    id: variantId
    },
    dataType: 'json', 
    success: function (data, textStatus, xhr) { 
      // self.find('.product-actions-container .added-to-cart-notice').addClass('active-note');
      // self.find('.product-actions-container .added-to-cart-notice').text('added to bag');
    },
    complete: async function (xhr, textStatus) {
      if(xhr.status == 200){
        let cartRes = await fetch(window.location.href);
        cartRes = await cartRes.text();
        let parser = new DOMParser();
        let doc = parser.parseFromString(cartRes, 'text/html');
        let countUpdate = doc.querySelector('.header__icon--cart').innerHTML;
        document.querySelector('.header__icon--cart').innerHTML = countUpdate;
        let drawerUpdate = doc.querySelector('cart-drawer').innerHTML;
        document.querySelector('cart-drawer').classList.remove("is-empty");
        document.querySelector('cart-drawer').innerHTML = drawerUpdate;
        await document.querySelector('.header__icon--cart').click();

        $('#modal-'+pid).removeClass('is-visible');
      } else {
        // self.find('.product-actions-container .added-to-cart-notice').text('sold out');
        // self.find('.product-actions-container .added-to-cart-notice').addClass('active-note');
      }
    }
  });
}

function checkVarint(type){
  let finalVarintVal = '';
  let pid= '';
  $('.modal.is-visible').find('.swatch_radio_0').each(function(){
    if($(this).hasClass('active')){
      finalVarintVal += $(this).attr('data-val');
      pid = $(this).attr('data-pid');
    }
  });
  $('.modal.is-visible').find('.swatch_radio_1').each(function(){
    if($(this).hasClass('active')){
      finalVarintVal += "_"+$(this).attr('data-val');
      pid = $(this).attr('data-pid');
    }
  });
  $('.modal.is-visible').find('.swatch_radio_2').each(function(){
    if($(this).hasClass('active')){
      finalVarintVal += "_"+$(this).attr('data-val');
      pid = $(this).attr('data-pid');
    }
  });
  finalVarintVal = finalVarintVal.toLowerCase();
  
  $('.modal.is-visible').find('.product__atc').text('ADD TO CART');
  if($('.modal.is-visible').find('#'+finalVarintVal).attr('data-available') == 'true'){
    if(type == 2){
      vatinatAddtocart($('.modal.is-visible'), $('.modal.is-visible').find('#'+finalVarintVal).val(), pid);
    }
  }
  else{
    $('.modal.is-visible').find('.product__atc').text('SOLD OUT');
  }
}

$('.swatch_radio_0').click(function(){
  $('.swatch_radio_0').removeClass('active');
  $(this).addClass('active');
  checkVarint(1);
});
$('.swatch_radio_1').click(function(){
  $('.swatch_radio_1').removeClass('active');
  $(this).addClass('active');
  checkVarint(1);
});
$('.swatch_radio_2').click(function(){
  $('.swatch_radio_2').removeClass('active');
  $(this).addClass('active');
  checkVarint(1);
});

$('.product__atc').click(function(){
  checkVarint('2');
});

function fnSelectVariant(productId, optionCounter){
  var finalVarintVal1 = '';
  if(optionCounter == 1){
    var selectVal1 = $('#card_'+productId+'_0 option:selected').text();
    selectVal1 = selectVal1.toLowerCase();
    finalVarintVal1 = selectVal1;
  }
  if(optionCounter == 2){
    var selectVal1 = $('#card_'+productId+'_0 option:selected').text();
    selectVal1 = selectVal1.toLowerCase();
    var selectVal2 = $('#card_'+productId+'_1 option:selected').text();
    selectVal2 = selectVal2.toLowerCase();
    finalVarintVal1 = selectVal1+'_'+selectVal2;
  }
  if(optionCounter == 3){
    var selectVal1 = $('#card_'+productId+'_0 option:selected').text();
    selectVal1 = selectVal1.toLowerCase();
    var selectVal2 = $('#card_'+productId+'_1 option:selected').text();
    selectVal2 = selectVal2.toLowerCase();
    var selectVal3 = $('#card_'+productId+'_2 option:selected').text();
    selectVal3 = selectVal3.toLowerCase();
    finalVarintVal1 = selectVal1+'_'+selectVal2+'_'+selectVal3;
  }
  var finalvId = $('#'+productId+'_'+finalVarintVal1).val();
  $('.'+productId+'-submit span').text('ADD TO CART');
  if($('#'+productId+'_'+finalVarintVal1).attr('data-available') == 'true'){
    $('#id_'+productId).val(finalvId);
  }
  else{
    $('.'+productId+'-submit span').text('SOLD OUT');
  }
}

/*
$('.product-grid .grid__item').each(async function(){
    let pc = $(this);
    let pcColor = pc.find('.attribute-options.inside .attribute-options__wrapper.colour a');
    let pcColorOutside = pc.find('.attribute-options.outside .attribute-options__wrapper.colour a');
    let pcSize = pc.find('.attribute-options .attribute-options__wrapper.size a');
    let pcBSize = pc.find('.attribute-options .attribute-options__wrapper.bottom-size a');
    let pcTSize = pc.find('.attribute-options .attribute-options__wrapper.top-size a');
    let selfSlider = pc.find('.collection-product-slider');
    const productHandle = pc.attr("data-product-handle");
    const variantJSON = await getProductById(productHandle);
    let selectedColor = pcColor .length > 0 ? pcColor.eq(0).attr('data-option-value') : "";
    let selectedSize = pcSize .length > 0 ? pcSize.eq(0).attr('data-option-value') : "";
    let selectedBSize = pcBSize .length > 0 ? pcBSize.eq(0).attr('data-option-value') : "";
    let selectedTSize = pcTSize .length > 0 ? pcTSize.eq(0).attr('data-option-value') : "";
    console.log(selectedTSize);
    if(pcColor.length > 0){
      pcColor.eq(0).addClass('active');
      pcColorOutside.eq(0).addClass('active');
      if(pcColor.length > 1){
        let optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
        setTimeout(()=>{ filter(selfSlider, optionAlt); },200);
        pcColor.each(function(){
          let thisClick = $(this);
          thisClick.click(function(){
              pcColor.removeClass('active');
              pcColorOutside.removeClass('active');
              $(this).addClass('active');
              $('.attribute-options.outside .attribute-options__wrapper.colour a[ data-option-value="' + $(this).attr("data-option-value") + '"]' ).addClass( 'active' );
              selectedColor = $(this).attr("data-option-value");
              // const selectedOptionColor = selectedColor +" / " + selectedSize;
              const selectedOptionColor = pcSize.length > 0 ? selectedColor +" / "+selectedSize : selectedColor;
              // variantPriceChange(pc, selectedOptionColor, variantJSON);
              optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
              filter(selfSlider, optionAlt);
          });
        });
        pcColorOutside.each(function(){
          let thisOutsideClick = $(this);
          thisOutsideClick.click(function(){
            pcColor.removeClass('active');
            pcColorOutside.removeClass('active');
            $(this).addClass('active');
            $('.attribute-options.inside .attribute-options__wrapper.colour a[ data-option-value="' + $(this).attr("data-option-value") + '"]' ).addClass( 'active' );
            selectedColor = $(this).attr("data-option-value");
            // const selectedOptionColorOs = selectedColor +" / " + selectedSize;
            const selectedOptionColorOs = pcSize.length > 0 ? selectedColor +" / "+selectedSize : selectedColor;
            // variantPriceChange(pc, selectedOptionColorOs, variantJSON);
            optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
            filter(selfSlider, optionAlt);
          });
        });
      }
    }
    if(pcSize.length > 0){
      pcSize.eq(0).addClass('active');
      pcSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcSize.removeClass('active');
              $(this).addClass('active');
              selectedSize = $(this).attr("data-option-value");
            console.log(selectedSize);
            // console.log(selectedSize.length);
              // const selectedOptionSize = selectedColor +" / " + selectedSize;
              const selectedOptionSize = pcColor.length > 0 ? selectedColor +" / "+selectedSize : selectedSize;
              // variantPriceChange(pc, selectedOptionSize, variantJSON);
              // const selectedOption = pcColor.length > 0 ? selectedColor +" / "+selectedSize : selectedSize ;
          });
      });
    }
    if(pcBSize.length > 0){
      pcBSize.eq(0).addClass('active');
      pcBSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcBSize.removeClass('active');
              $(this).addClass('active');
              selectedBSize = $(this).attr("data-option-value");
              console.log(selectedBSize);
            // console.log(selectedBSize.length);
              // const selectedOptionSize = selectedColor +" / " + selectedSize;
              const selectedOptionBSize = selectedTSize.length > 0 ? selectedTSize +" / "+selectedBSize : selectedBSize;
              // variantPriceChange(pc, selectedOptionSize, variantJSON);
              // const selectedOption = pcColor.length > 0 ? selectedColor +" / "+selectedSize : selectedSize ;
          });
      });
    }
    if(pcTSize.length > 0){
      pcTSize.eq(0).addClass('active');
      pcTSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcTSize.removeClass('active');
              $(this).addClass('active');
              selectedTSize = $(this).attr("data-option-value");
            console.log(selectedTSize);
            // console.log(selectedTSize.length);
              // const selectedOptionSize = selectedColor +" / " + selectedSize;
              const selectedOptionTSize = pcTSize.length > 0 ? selectedTSize +" / "+selectedBSize : selectedTSize;
              // variantPriceChange(pc, selectedOptionSize, variantJSON);
              // const selectedOption = pcColor.length > 0 ? selectedColor +" / "+selectedSize : selectedSize ;
          });
      });
    }
    
    pc.find('.product__atc').click(async function(){
      // const selectedOption = selectedColor +" / " + selectedSize;
      let selectedOption;
      if(pcColor.length > 0 && pcSize.length < 1) {
        selectedOption = selectedColor;
      } else if(pcSize.length > 0 && pcColor.length < 1) {
        selectedOption = selectedSize;
      } else if(pcSize.length > 0 && pcColor.length > 0) {
        selectedOption = selectedColor +" / " + selectedSize;
      }else if(pcBSize.length > 0 && pcTSize.length < 1) {
        selectedOption = selectedTSize;
      } else if(pcBSize.length > 1 && pcTSize.length < 0) {
        selectedOption = selectedBSize;
      } else if(pcBSize.length > 0 && pcTSize.length > 0) {
        selectedOption = selectedTSize +" / " + selectedBSize;
      }
      console.log(selectedOption);
      const selectedVariantId = variantJSON.filter(variant => variant.title === selectedOption).map(variant => variant.id);
      const selectedVariantAvailable = variantJSON.filter(variant => variant.title === selectedOption).map(variant => variant.available);
      if(selectedVariantAvailable == 'true'){
        await variantATC(pc, selectedVariantId);
      }else{
        pc.find('.product-actions-container .added-to-cart-notice').text('sold out');
        pc.find('.product-actions-container .added-to-cart-notice').addClass('active-note');              
        }
      setTimeout(()=>{
        pc.find('.product-actions-container .added-to-cart-notice').removeClass('active-note');
      },3000);
    });
});
*/

/*
$('.color-swatch-list-a').click(function(){
  let pc = $(this).parent().parent().parent();
    let pcColor = pc.find('.attribute-options.inside .attribute-options__wrapper.colour a');
    let pcColorOutside = pc.find('.attribute-options.outside .attribute-options__wrapper.colour a');
    let pcSize = pc.find('.attribute-options .attribute-options__wrapper.size a');
    let pcBSize = pc.find('.attribute-options .attribute-options__wrapper.bottom-size a');
    let pcTSize = pc.find('.attribute-options .attribute-options__wrapper.top-size a');
    let selfSlider = pc.find('.collection-product-slider');
    
    let selectedColor = pcColor .length > 0 ? pcColor.eq(0).attr('data-option-value') : "";
    let selectedSize = pcSize .length > 0 ? pcSize.eq(0).attr('data-option-value') : "";
    let selectedBSize = pcBSize .length > 0 ? pcBSize.eq(0).attr('data-option-value') : "";
    let selectedTSize = pcTSize .length > 0 ? pcTSize.eq(0).attr('data-option-value') : "";
    console.log(selectedTSize);
  
    if(pcColor.length > 0){
      pcColor.eq(0).addClass('active');
      pcColorOutside.eq(0).addClass('active');
      if(pcColor.length > 1){
        let optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
        setTimeout(()=>{ filter(selfSlider, optionAlt); },200);
        pcColor.each(function(){
          let thisClick = $(this);
          thisClick.click(function(){
              pcColor.removeClass('active');
              pcColorOutside.removeClass('active');
              $(this).addClass('active');
              $('.attribute-options.outside .attribute-options__wrapper.colour a[ data-option-value="' + $(this).attr("data-option-value") + '"]' ).addClass( 'active' );
              selectedColor = $(this).attr("data-option-value");
              // const selectedOptionColor = selectedColor +" / " + selectedSize;
              const selectedOptionColor = pcSize.length > 0 ? selectedColor +" / "+selectedSize : selectedColor;
              // variantPriceChange(pc, selectedOptionColor, variantJSON);
              optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
              filter(selfSlider, optionAlt);
          });
        });
        pcColorOutside.each(function(){
          let thisOutsideClick = $(this);
          thisOutsideClick.click(function(){
            pcColor.removeClass('active');
            pcColorOutside.removeClass('active');
            $(this).addClass('active');
            $('.attribute-options.inside .attribute-options__wrapper.colour a[ data-option-value="' + $(this).attr("data-option-value") + '"]' ).addClass( 'active' );
            selectedColor = $(this).attr("data-option-value");
            // const selectedOptionColorOs = selectedColor +" / " + selectedSize;
            const selectedOptionColorOs = pcSize.length > 0 ? selectedColor +" / "+selectedSize : selectedColor;
            // variantPriceChange(pc, selectedOptionColorOs, variantJSON);
            optionAlt = 'color_'+selectedColor.toLowerCase().replace(/ /g,'-');
            filter(selfSlider, optionAlt);
          });
        });
      }
    }
    if(pcSize.length > 0){
      console.log("eeee");
      pcSize.eq(0).addClass('active');
      pcSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcSize.removeClass('active');
              $(this).addClass('active');
              selectedSize = $(this).attr("data-option-value");
            console.log("selectedSize---->"+selectedSize);
              const selectedOptionSize = pcColor.length > 0 ? selectedColor +" / "+selectedSize : selectedSize;
          });
      });
    }
    if(pcBSize.length > 0){
      pcBSize.eq(0).addClass('active');
      pcBSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcBSize.removeClass('active');
              $(this).addClass('active');
              selectedBSize = $(this).attr("data-option-value");
              console.log("selectedBSize--->"+selectedBSize);
              const selectedOptionBSize = selectedTSize.length > 0 ? selectedTSize +" / "+selectedBSize : selectedBSize;
          });
      });
    }
    if(pcTSize.length > 0){
      pcTSize.eq(0).addClass('active');
      pcTSize.each(function(){
          let thisClick = $(this);
          thisClick.click(async function(){
              pcTSize.removeClass('active');
              $(this).addClass('active');
              selectedTSize = $(this).attr("data-option-value");
            console.log("selectedTSize---->"+selectedTSize);
              const selectedOptionTSize = pcTSize.length > 0 ? selectedTSize +" / "+selectedBSize : selectedTSize;
          });
      });
    }

    console.log("selectedSize==>"+selectedSize);
    console.log("selectedTSize==>"+selectedTSize);
    console.log("selectedBSize==>"+selectedBSize);
    let selectedOption;
    if(pcColor.length > 0 && pcSize.length < 1) {
      selectedOption = selectedColor;
    } else if(pcSize.length > 0 && pcColor.length < 1) {
      selectedOption = selectedSize;
    } else if(pcSize.length > 0 && pcColor.length > 0) {
      selectedOption = selectedColor +" / " + selectedSize;
    }else if(pcBSize.length > 0 && pcTSize.length < 1) {
      selectedOption = selectedTSize;
    } else if(pcBSize.length > 1 && pcTSize.length < 0) {
      selectedOption = selectedBSize;
    } else if(pcBSize.length > 0 && pcTSize.length > 0) {
      selectedOption = selectedTSize +" / " + selectedBSize;
    }

  const search = ' / ';
  const replaceWith = '_';
  var newselectedOption = selectedOption.split(search).join(replaceWith);
    console.log("selectedOption==>"+newselectedOption);
});
*/


$(document).ready(function() {
  $("#toggle").click(function() {
    var elem = $("#toggle").text();
    if (elem == "Read More") {
      //Stuff to do when btn is in the read more state
      $("#toggle").text("Read Less");
      $("#text").addClass('readmore');
    } else {
      //Stuff to do when btn is in the read less state
      $("#toggle").text("Read More");
      $("#text").removeClass('readmore');
    }
  });
});